



















































import { titleize } from 'underscore.string'
import Vue from 'vue'
export default Vue.extend({
  data() {
    return {
      clientMapLoaded: true,
      search: {
        active: false,
        text: null
      }
    }
  },
  computed: {
    title():string {
      return this.$route.meta.title || titleize(this.$route.params.resource) || titleize(this.$route.name || "").replace("page", "")
    }
  },
  methods: {
    onSearchButtonClick() {
      if (this.search.active) {
        if (!this.search.text) {
          this.search.active = false
        }
      } else {
        this.search.active = true
        const searchInput = document.getElementById('searchInput')
        const focusSearchInput = setInterval(() => {
          if (searchInput) {
            searchInput.focus()
            clearInterval(focusSearchInput)
          }
        }, 50)
        searchInput ? searchInput.focus() : null
      }
    }
  },
  mounted() {
  }
})
